import { makeToggleCard } from '../Checkable/ToggleCard'

export default makeToggleCard({ type: 'radio', displayName: 'RadioCard', groupRole: 'radiogroup' })
